<template>
  <HorizontalField :name="name" :label="label" :class="{ 'is-required': required }">
    <input
      :type="type"
      class="input"
      :required="required"
      :name="name"
      :id="name"
      :value="value"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)" />
    <template v-slot:info>
      <slot></slot>
    </template>
  </HorizontalField>
</template>

<script>
import HorizontalField from "./HorizontalField";

export default {
  name: "input-field",
  props: {
    type: {
      type: String,
      default: "text",
    },
    name: String,
    label: String,
    value: String,
    disabled: Boolean,
    required: Boolean,
  },
  components: { HorizontalField },
};
</script>

<style scoped></style>
